export function EmptyState({ icon: Icon, title, subtitle, action }) {
    return (
        <div className="flex flex-col items-center justify-center text-center py-16 border border-dashed border-border rounded-sm bg-surface/40" data-testid="empty-state">
            {Icon && <Icon className="w-9 h-9 text-muted-foreground mb-4" />}
            <h3 className="font-heading text-lg font-semibold text-white">{title}</h3>
            {subtitle && <p className="mt-1.5 text-sm text-muted-foreground max-w-md">{subtitle}</p>}
            {action && <div className="mt-5">{action}</div>}
        </div>
    );
}
